import { render, staticRenderFns } from "./FormV2.vue?vue&type=template&id=09b88dc2&"
import script from "./FormV2.vue?vue&type=script&lang=js&"
export * from "./FormV2.vue?vue&type=script&lang=js&"
import style0 from "./FormV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VBtn,VIcon,VSnackbar,VThemeProvider})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b88dc2')) {
      api.createRecord('09b88dc2', component.options)
    } else {
      api.reload('09b88dc2', component.options)
    }
    module.hot.accept("./FormV2.vue?vue&type=template&id=09b88dc2&", function () {
      api.rerender('09b88dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/FormV2.vue"
export default component.exports